import { css } from "@emotion/react"
import { Designation, Frequency, Memo, ValidationErrors } from "../types"
import { FrequencySelector } from "./FrequencySelector"
import { FundSelection } from "./FundSelection"
import { MemoLine } from "./MemoLine"

type LeftPaneProps = {
  designations: Designation[]
  frequency: Frequency
  editFrequencyExpanded: boolean
  errors: ValidationErrors
  focusedDesignationIndex: number
  memo: Memo
}
export function LeftPane({
  designations,
  frequency,
  editFrequencyExpanded,
  errors,
  focusedDesignationIndex,
  memo,
}: LeftPaneProps) {
  return (
    <div
      className="d-f fd-c g-5 g-4@md f-2"
      css={css`
        min-width: 0; // allow flex items to shrink
        flex-basis: 60%;
      `}
    >
      <FundSelection
        {...{ designations, frequency, errors, focusedDesignationIndex }}
      />
      <FrequencySelector
        {...{ frequency }}
        editExpanded={editFrequencyExpanded}
      />
      {memo.eligible && <MemoLine memo={memo} />}
    </div>
  )
}
